/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { MemoryRouter } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useAuthTokenInitialization } from "../hooks/useAuthTokenInitialization";
import { useSchedulerInitialization } from "../hooks/useSchedulerInitialization";
import LoadingIndicator from "../components/LoadingIndicator";

export const BootGate = ({ children }) => {
  const { isInitialized } = useAuth();
  useAuthTokenInitialization();
  const { isLoading: isSchedulerLoading, initialRoute } = useSchedulerInitialization();

  if (!isInitialized || isSchedulerLoading) {
    return <LoadingIndicator page />;
  }

  // "/" stays below the initial route so Back returns to Home
  return <MemoryRouter initialEntries={initialRoute ? ["/", initialRoute] : ["/"]}>{children}</MemoryRouter>;
};
